import React, { Component } from 'react';

import classNames from 'classnames';
import { ReactComponent as CheckGreenCosmos } from 'components/svg/icons/check-green-cosmos.svg';
import { I18n } from 'components/translate';
import { inject } from 'mobx-react';
import {
  EVENT_ACTIONS,
  EVENTS_INTERACTIONS,
  EVENTS_CATEGORY
} from 'modules/app/services/datahub/constants';
import DatahubService from 'modules/app/services/datahub/DatahubService';
import { buildInteractionEventData } from 'modules/app/services/datahub/helper';
import GtagService from 'modules/app/services/ga/GtagService';
import PropTypes from 'prop-types';

import {
  Step,
  Status,
  StepStatus,
  ChecklistHeadingLabel,
  getChecklistSettings
} from './settings';

import './OnboardingChecklist.scss';

const renderChecklistSteps = (currentStep, isOnlineEvent) => {
  return getChecklistSettings(isOnlineEvent).map((stepSettings, index) => {
    const isDone = currentStep > stepSettings.stepNumber;
    const isChecked = StepStatus[currentStep][index] === Status.CHECK;
    const isFilled = StepStatus[currentStep][index] === Status.FILLED;
    const isEmpty = StepStatus[currentStep][index] === Status.EMPTY;

    return (
      <li
        key={stepSettings.stepNumber}
        className="onboarding-checklist__step"
        data-test="onboarding-checklist-step"
      >
        {isChecked ? (
          <span className="onboarding-checklist__step-done">
            <CheckGreenCosmos />
          </span>
        ) : (
          <span
            className={classNames('onboarding-checklist__step-number', {
              'onboarding-checklist__step-number__filled': isFilled,
              'onboarding-checklist__step-number__empty': isEmpty
            })}
          >
            {stepSettings.stepNumber}
          </span>
        )}
        <span className="onboarding-checklist__step__text">
          <I18n
            label={isDone ? stepSettings.doneLabel : stepSettings.todoLabel}
          />
        </span>
      </li>
    );
  });
};

@inject((stores) => ({
  onlineEvent: stores.MembershipStore.onlineEvent
}))
class OnboardingChecklist extends Component {
  static propTypes = {
    currentStep: PropTypes.oneOf([Step.MODULE, Step.CONTENT, Step.PUBLISH])
      .isRequired,
    onlineEvent: PropTypes.bool
  };

  sendEventOnboardingWhenOnboardingShow() {
    const { currentStep } = this.props;
    const eventLabel = new Map();

    eventLabel.set(Step.MODULE, 'AddModule');
    eventLabel.set(Step.CONTENT, 'AddContent');
    eventLabel.set(Step.PUBLISH, 'PublishModule');

    GtagService.sendEvent({
      event: 'noninteraction',
      category: 'Club:Admin:Content',
      action: 'Show',
      where: 'Onboarding',
      label: eventLabel.get(currentStep)
    });

    DatahubService.sendEvent({
      action: EVENT_ACTIONS.INTERACT,
      event: buildInteractionEventData({
        category: EVENTS_CATEGORY.CONTENT.CONTENT_ONBOARDING,
        action: EVENTS_INTERACTIONS.SHOW,
        label: eventLabel.get(currentStep)
      })
    });
  }

  componentDidMount() {
    this.sendEventOnboardingWhenOnboardingShow();
  }

  componentDidUpdate() {
    this.sendEventOnboardingWhenOnboardingShow();
  }

  render() {
    const { currentStep, onlineEvent } = this.props;

    return (
      <div data-test="onboarding-checklist" className="onboarding-checklist">
        <h3 className="onboarding-checklist__title _mb-4">
          <I18n label={ChecklistHeadingLabel[currentStep]} />
        </h3>
        <ol>{renderChecklistSteps(currentStep, onlineEvent)}</ol>
      </div>
    );
  }
}

export default OnboardingChecklist;
